import { z } from "zod";

export const PermissionRoleValues = [
  "REMI_OPS",
  "REMI_USER",
  "REMI_SALES",
  "REMI_SALES_ADMIN",
  "REMI_ADMIN",
  "REMI_AI_OPERATIONS",
  "REMI_COMPLIANCE",
  "REMI_COMPLIANCE_ADMIN",
  "REMI_ENGINEER",
  "IMPERSONATOR",
  "REMI_IMPERSONATION_AUDITOR",
  "REMI_AUTOMATIONS",
  "REMI_DESIGNER",
  "REMI_FINANCIAL",
  "REMI_FINANCIAL_ADMIN",
  "REMI_QUOTE_ADMIN",
  "REMI_REGIONAL_MANAGER",
  "REMI_DEADLINE_MANAGER",
  "REMI_PERMISSIONS_MANAGER",
  "REMI_CHANGE_ORDER_MANAGER",
  "REMI_WORK_ORDER_MANAGER",
  "REMI_DISPATCH",
  "REMI_CHANGE_ORDER_SPECIALIST",
  "REMI_ACCOUNT_MANAGEMENT_LEAD",
  "REMI_ACCOUNT_MANAGER",
  "REMI_QUOTING",
  "REMI_CLAIM_CAPTURE_TEAM",
  "REMI_MCP_USER",
  "REMI_MARKETING_WEBSITE",
  "AUTONOMOUS_AGENT",
  "CONTRACTOR_ADMIN",
  "CONTRACTOR_PRODUCTION",
  "NOMAD_INSPECTION",
  "NOMAD_QA",
  "NOMAD_CORRECTION",
  "BUYER_ADMIN",
  "INVALID",
  "HOMEOWNER",
  "PARTNER_DEVELOPER",
  "INSURANCE_ADJUSTER",
  "FIELD_WORKER",
  "ESTIMATOR",
  "ESTIMATE_REVIEWER",
  "ESTIMATE_ADMIN",
] as const;

// Permission role display names for better UX
export const PermissionRoleDisplayNames: Readonly<Record<PermissionRole, string>> = {
  REMI_OPS: "Remi Operations",
  REMI_USER: "Remi User",
  REMI_SALES: "Remi Sales",
  REMI_SALES_ADMIN: "Remi Sales Admin",
  REMI_ADMIN: "Remi Admin",
  REMI_AI_OPERATIONS: "Remi AI Operations",
  REMI_COMPLIANCE: "Remi Compliance",
  REMI_COMPLIANCE_ADMIN: "Remi Compliance Admin",
  REMI_ENGINEER: "Remi Engineer",
  IMPERSONATOR: "Impersonator",
  REMI_IMPERSONATION_AUDITOR: "Remi Impersonation Auditor",
  REMI_AUTOMATIONS: "Remi Automations",
  REMI_DESIGNER: "Remi Designer",
  REMI_FINANCIAL: "Remi Financial",
  REMI_FINANCIAL_ADMIN: "Remi Financial Admin",
  REMI_QUOTE_ADMIN: "Remi Quote Admin",
  REMI_REGIONAL_MANAGER: "Remi Regional Manager",
  REMI_DEADLINE_MANAGER: "Remi Deadline Manager",
  REMI_PERMISSIONS_MANAGER: "Remi Permissions Manager",
  REMI_CHANGE_ORDER_MANAGER: "Remi Change Order Manager",
  REMI_WORK_ORDER_MANAGER: "Remi Work Order Manager",
  REMI_DISPATCH: "Remi Dispatch",
  REMI_CHANGE_ORDER_SPECIALIST: "Remi Change Order Specialist",
  REMI_ACCOUNT_MANAGEMENT_LEAD: "Remi Account Management Lead",
  REMI_ACCOUNT_MANAGER: "Remi Account Manager",
  REMI_QUOTING: "Remi Quoting",
  REMI_CLAIM_CAPTURE_TEAM: "Remi Claim Capture Team",
  REMI_MCP_USER: "Remi MCP User",
  REMI_MARKETING_WEBSITE: "Remi Marketing Website",
  AUTONOMOUS_AGENT: "Autonomous Agent",
  CONTRACTOR_ADMIN: "Contractor Admin",
  CONTRACTOR_PRODUCTION: "Contractor Production",
  NOMAD_INSPECTION: "Nomad Site Inspection",
  NOMAD_QA: "Nomad Quality Assurance",
  NOMAD_CORRECTION: "Nomad Corrections QA",
  BUYER_ADMIN: "Buyer Admin",
  INVALID: "Invalid",
  HOMEOWNER: "Homeowner",
  PARTNER_DEVELOPER: "Partner Developer",
  INSURANCE_ADJUSTER: "Insurance Adjuster",
  FIELD_WORKER: "Field Worker",
  ESTIMATOR: "Estimator",
  ESTIMATE_REVIEWER: "Estimate Reviewer",
  ESTIMATE_ADMIN: "Estimate Admin",
};

export const PermissionRoleSchema = z.enum(PermissionRoleValues);
export const PermissionRole = PermissionRoleSchema.enum;
export type PermissionRole = (typeof PermissionRoleValues)[number];
